import { InherentRiskCategoryEnum } from '@/gen/inventory/v1/company_service_pb'

import { SourceAvatar } from '@/pages/company-drawer/company-overview/set-irq-modal/lema-suggestions-card/source-avatar'
import { SourceBody } from '@/pages/company-drawer/company-overview/set-irq-modal/lema-suggestions-card/source-body'
import type { SourceDisplay } from '@/pages/company-drawer/company-overview/set-irq-modal/lema-suggestions-card/types'

type InsightSectionProps = {
  sources: SourceDisplay[]
  answer: string
  categoryEnum: InherentRiskCategoryEnum
  businessOwnerName?: string
}

export const InsightSection = ({
  sources,
  answer,
  categoryEnum,
  businessOwnerName,
}: InsightSectionProps) => (
  <div className='flex flex-col gap-1 px-2.5 pb-2'>
    {sources.map((s) => (
      <div
        key={s.key}
        className='flex flex-col gap-1 rounded border border-main-border-default p-2'
      >
        <div className='flex items-center gap-1.5'>
          <SourceAvatar label={s.name}>{s.icon}</SourceAvatar>
          <span className='text-main-foreground-primary text-label-default'>{s.name}</span>
        </div>
        <SourceBody
          source={s}
          answer={answer}
          categoryEnum={categoryEnum}
          businessOwnerName={businessOwnerName}
        />
      </div>
    ))}
  </div>
)
